<template>
	<div class="por">
		<img class="wp100 hv100 fixed" style="z-index: -1;" src="@/static/404-background.png" alt="" />
		<div class="flex-text flex-v" style="padding: 10vh 0;">
			<img class="" style="width: 692px;height: 342px;" src="@/static/404.png" alt="" />
			<div class="fwb mt30" style="color: #616161;font-size: 40px;">Page missing</div>
			<div class="color-white text-center" style="font-size: 60px;margin-top: 120px;">You visit the <br> page does not exist !</div>
		</div>
	</div>
</template>

<script>
export default{
	name: 'NoFound',
	data(){
		return{
			
		}
	},
	mounted(){
		
	},
	methods: {
		
	}
}
</script>

<style>
</style>